import NSPCheckbox from '@components/ui/NSPCheckbox';
import { Form, Input, InputNumber, Select } from 'antd';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  children,
  options, // <-- receive options
  trueValue = true,
  falseValue = false,
  ...restProps
}) => {
  let inputNode;

  // choose input type
  if (inputType === 'number') {
    inputNode = <InputNumber />;
  } else if (inputType === 'select') {
    inputNode = (
      <Select
        style={{ minWidth: '150px' }}
        options={options?.map((opt) => ({ value: opt, label: opt }))}
      />
    );
  } else if (inputType === 'checkbox') {
    inputNode = <NSPCheckbox />;
  } else {
    inputNode = <Input />;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          valuePropName={inputType === 'checkbox' ? 'checked' : 'value'}
          getValueProps={(value) => {
            if (inputType === 'checkbox') {
              return { checked: value === trueValue };
            }
            return { value };
          }}
          getValueFromEvent={(e) => {
            if (inputType === 'checkbox') {
              return e.target.checked ? trueValue : falseValue;
            }
            return e;
          }}
          rules={[
            {
              required: false,
              message: `Please input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;
